export default __webpack_public_path__ + "static/media/logo.f9af8f2c.svg";